<template>
  <div>
    <b-container>
      <div v-if="loading">
        <b-icon icon="circle-fill" animation="throb"></b-icon>
        {{ $t('common.loading') }}
      </div>
    </b-container>
  </div>
</template>

<script>
  import ApiService from '../../services/api'

  export default {
    data() {
      return {
        loading: true,
      }
    },

    mounted() {
      const redirectToHome = () => {
        this.$route.query.ci = undefined
        this.$route.query.oct = undefined

        return this.$router.push({ name: 'home', query: this.$route.query })
      }

      if (!this.$route.query.ci || !this.$route.query.oct) {
        return redirectToHome()
      }

      ApiService
        .unregisterToWorkshop(this.$route.params.workshopUuid, {
          customerId: this.$route.query.ci,
          customerOCT: this.$route.query.oct,
        })
        .then(() => {
          this.$swal(
            this.$i18n.t('workshops.notifications.unregistered.title'),
            this.$i18n.t('workshops.notifications.unregistered.message')
          )
            .then(() => {
              return redirectToHome()
            })
        })
        .catch(() => {
          this.$swal(this.$i18n.t('errors.base'))
            .then(() => {
              return redirectToHome()
            })
        })
        .finally(() => this.loading = false)
    },
  }
</script>
